<div>
  @if (txnData) {
    <div class="row">
      <div class="col">
        <h6>
          <span class="dropdown" dropdown>
            <a
              href
              id="basic-link"
              dropdownToggle
              (click)="$event.preventDefault()"
              (keydown.enter)="$event.preventDefault()"
              aria-controls="basic-link-dropdown"
              >{{ activeChartType.name }} <i class="fa fa-angle-down"></i
            ></a>
            <ul
              id="basic-link-dropdown"
              *dropdownMenu
              class="dropdown-menu"
              role="menu"
              aria-labelledby="basic-link">
              @for (val of chartTypes; track val) {
                <a
                  class="dropdown-item"
                  [class.active]="activeChartType == val"
                  (click)="setChartType(val)"
                  (keydown.enter)="setChartType(val)"
                  >{{ val.name }}</a
                >
              }
            </ul>
          </span>
          per
          <span class="dropdown" dropdown>
            <a
              href
              id="basic-link"
              dropdownToggle
              (click)="$event.preventDefault()"
              (keydown.enter)="$event.preventDefault()"
              aria-controls="basic-link-dropdown"
              >{{ activeXAxisType.name }} <i class="fa fa-angle-down"></i
            ></a>
            <ul
              id="basic-link-dropdown"
              *dropdownMenu
              class="dropdown-menu"
              role="menu"
              aria-labelledby="basic-link">
              @for (val of xAxisTypes; track val) {
                <a
                  class="dropdown-item"
                  [class.active]="activeXAxisType == val"
                  (click)="setXAxisType(val)"
                  (keydown.enter)="setXAxisType(val)"
                  >{{ val.name }}</a
                >
              }
            </ul>
          </span>
          split on
          <span class="dropdown" dropdown>
            <a
              href
              id="basic-link"
              dropdownToggle
              (click)="$event.preventDefault()"
              (keydown.enter)="$event.preventDefault()"
              aria-controls="basic-link-dropdown"
              >{{ activeStackType.name }} <i class="fa fa-angle-down"></i
            ></a>
            <ul
              id="basic-link-dropdown"
              *dropdownMenu
              class="dropdown-menu"
              role="menu"
              aria-labelledby="basic-link">
              @for (val of stackTypes; track val) {
                <a
                  class="dropdown-item"
                  [class.active]="activeStackType == val"
                  (click)="setStackType(val)"
                  (keydown.enter)="setStackType(val)"
                  >{{ val.name }}</a
                >
              }
            </ul>
          </span>
          in
          <span class="dropdown" dropdown>
            <a
              href
              id="basic-link"
              dropdownToggle
              (click)="$event.preventDefault()"
              (keydown.enter)="$event.preventDefault()"
              aria-controls="basic-link-dropdown"
              >{{ activeCurrency.name }} <i class="fa fa-angle-down"></i
            ></a>
            <ul
              id="basic-link-dropdown"
              *dropdownMenu
              class="dropdown-menu"
              role="menu"
              aria-labelledby="basic-link">
              @for (val of currencies; track val) {
                <a
                  class="dropdown-item"
                  [class.active]="activeCurrency == val"
                  (click)="setCurrency(val)"
                  (keydown.enter)="setCurrency(val)"
                  >{{ val.name }}</a
                >
              }
            </ul>
          </span>
        </h6>
      </div>
    </div>
  }

  @if (txnData) {
    <div class="row">
      @for (total of totalsTypes; track total) {
        <div class="col-lg-3">
          <div class="card">
            <div class="card-body p-0 clearfix">
              <i
                class="fa fa-cogs bg-primary p-4 font-2xl me-3 float-start"></i>
              @if (txnData.totals[total].count) {
                <div class="h5 text-primary mb-0 pt-2">
                  {{
                    txnData.totals[total].amount
                      | currency: activeCurrency.name : 'symbol'
                  }}
                </div>
              }
              @if (!txnData.totals[total].count) {
                <div class="h5 text-primary mb-0 pt-2">---</div>
              }
              <div class="h6 text-secondary mb-0">
                {{ txnData.totals[total].count }} TRX
              </div>
              <div class="text-muted text-uppercase fw-bold font-xs">
                {{ txnData.totals[total].name }}
              </div>
            </div>
          </div>
        </div>
      }
    </div>
  }
  <div class="row">
    <div class="col">
      <div
        class="chart-container"
        [hidden]="!chart"
        style="position: relative; height: 40vh">
        <canvas id="canvas" [attr.data]="txnData?.totals | json">{{
          chart
        }}</canvas>
      </div>
      @if (!chart) {
        <div class="alert alert-info row g-0">
          <div class="col">
            <h5>No Results</h5>
            No results for current filter or date range.
          </div>
        </div>
      }
    </div>
  </div>
  @if (loading$ | async) {
    <loader-line></loader-line>
  }
</div>
